var _circle, _circle2, _circle3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeoples(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 35.625,
    r: 16.875,
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.875,
    cy: 51.25,
    r: 12.5,
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.125,
    cy: 51.25,
    r: 12.5,
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6875 119.375H93.375C93.9273 119.375 94.375 118.927 94.375 118.375V81.5625C94.375 75.9375 87.25 62.8125 70 62.8125C52.75 62.8125 44.6875 75.625 44.6875 81.5625V118.375C44.6875 118.927 45.1352 119.375 45.6875 119.375Z",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 112.5H43.375C43.9273 112.5 44.375 112.052 44.375 111.5V84.924C44.375 80.8218 39.1769 71.25 26.592 71.25C14.0071 71.25 8.125 80.5939 8.125 84.924V111.5C8.125 112.052 8.57272 112.5 9.125 112.5Z",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.375 112.5H129.625C130.177 112.5 130.625 112.052 130.625 111.5V84.924C130.625 80.8218 125.427 71.25 112.842 71.25C100.257 71.25 94.375 80.5939 94.375 84.924V111.5C94.375 112.052 94.8227 112.5 95.375 112.5Z",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoples);
export default __webpack_public_path__ + "static/media/peoples.f9e8e6a06f6a389aa1a8bdb8520d1250.svg";
export { ForwardRef as ReactComponent };